// extracted by mini-css-extract-plugin
module.exports = {"menu-left":"SubMenu_menu-left__3pVoB","active":"SubMenu_active__25tCD","boeken":"SubMenu_boeken__1bHES"};